import styled from 'styled-components'
import { Flex, Box } from 'vvs-uikit'
import CardButton from 'views/VvsGotchi/components/CardButton'

export const TeamMainSection = styled(Flex)`
  width: 100%;
  background-image: url('/images/vvsGotchi/bg_purple.png');
  background-size: cover;
  background-position: center;
  padding: 1rem 1rem 2rem 1rem;
  flex-direction: column;
`

export const DashboardNoticeFlex = styled(Flex)<{ type: 'info' | 'warn'; onClick?: any }>`
  padding: 6px 10px;
  border-radius: 8px;
  align-items: center;
  gap: 8px;
  border: 3px solid
    ${({ type, theme }) =>
      type === 'info' ? theme.colors.darkGrey : /* type === 'warn' */ theme.colors.gotchiErrorPink};

  &:not(:first-child) {
    margin-top: 8px;
  }

  ${({ onClick }) =>
    onClick &&
    `
    cursor: pointer;
  `}
`

export const HealthCareFlex = styled(Flex)`
  flex-direction: column;
  max-width: 165px;
  margin: 0 auto;
  height: 100%;
`

export const HealthCareButton = styled(CardButton)<{ state: 'need-action' | 'done' | 'no-mole' | 'max-health' }>`
  text-align: left;
  border: none;
  height: auto;
  padding: 20px 0 16px;
  gap: 12px;
  flex-grow: 1;
  ${({ state, theme }) =>
    state === 'need-action'
      ? `
        background-color: ${theme.colors.gotchiErrorLighterPink};
        border: 3px solid ${theme.colors.gotchiErrorPink};
      `
      : state === 'done' || state === 'max-health'
      ? `
        background-color: ${theme.colors.gotchiSuccessLighterGreen};
        border: 3px solid ${theme.colors.gotchiSuccessGreen};
      ` // state === 'no-mole'
      : `
        background-color: ${theme.colors.lightBeige};
        border: 3px solid ${theme.colors.darkGrey};
      `}
`

export const HealthCareButtonTextsBox = styled(Box)`
  padding: 0 10px;
  ${({ theme }) => theme.mediaQueries.xs} {
    padding: 0 16px;
  }
`
